// [EQIQ-016] Import UpdateDealThreadResponseContent from '@equaliq/api-model'
// once the package exports it; today we duplicate the shape below.
import { createApiRequest } from '../common';

interface UpdateDealThreadResponse {
  success: boolean;
  dealThread: {
    dealThreadId: string;
    dealId: string;
    threadMetadataId: string;
    associationType: string;
    status: string;
    notes?: string;
    createdAt: string;
    updatedAt: string;
  };
}

/**
 * Update a deal-thread association (status and/or notes).
 * POST /deals/threads/update (flat route -- dealId and dealThreadId in body)
 */
export const updateDealThreadApi = async (
  dealId: string,
  dealThreadId: string,
  request: { status?: string; notes?: string }
): Promise<UpdateDealThreadResponse> => {
  const apiRequest = createApiRequest<UpdateDealThreadResponse>(
    'post',
    '/deals/threads/update'
  );
  return apiRequest({ dealId, dealThreadId, ...request });
};
